export const CART_STORAGE_KEY = 'checkoutCart';
export const LEGACY_CART_STORAGE_KEY = 'selectedRecipients';

let subscribers = [];

const readCartFromStorage = () => {
  const storageKeys = [CART_STORAGE_KEY, LEGACY_CART_STORAGE_KEY];
  for (const key of storageKeys) {
    const storedValue = localStorage.getItem(key);
    if (!storedValue) continue;
    try {
      const parsed = JSON.parse(storedValue);
      if (Array.isArray(parsed)) {
        return parsed;
      }
    } catch (error) {
      console.error(`CartService: Failed to parse data for key ${key}`, error);
    }
  }
  return [];
};

let cartCache = [];

export const getCart = () => {
  if (!cartCache.length) {
    cartCache = readCartFromStorage();
  }
  return cartCache;
};

export const setCart = (items) => {
  cartCache = Array.isArray(items) ? items : [];
  const serialised = JSON.stringify(cartCache);
  localStorage.setItem(CART_STORAGE_KEY, serialised);
  localStorage.setItem(LEGACY_CART_STORAGE_KEY, serialised);
  subscribers.forEach((callback) => {
    try {
      callback(cartCache);
    } catch (error) {
      console.error('CartService: subscriber callback failed', error);
    }
  });
};

export const appendToCart = (item) => {
  const current = getCart();
  setCart([...current, item]);
};

export const clearCart = () => {
  setCart([]);
};

export const subscribeToCart = (callback) => {
  if (typeof callback !== 'function') return () => {};
  subscribers.push(callback);
  // Emit current value immediately
  callback(getCart());
  return () => {
    subscribers = subscribers.filter((fn) => fn !== callback);
  };
};

export const removeFromCartByIndex = (index) => {
  const current = getCart();
  if (index < 0 || index >= current.length) return;
  const updated = current.filter((_, idx) => idx !== index);
  setCart(updated);
};
